import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-speaker" }
const _hoisted_2 = { class: "page-inner" }
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "nav" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PictureViewer = _resolveComponent("PictureViewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "pc-banner",
          src: _ctx.detailData.bannerImg,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          class: "wap-banner",
          src: _ctx.detailData.bannerWapImg,
          alt: ""
        }, null, 8, _hoisted_5),
        _createElementVNode("span", {
          class: "back-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
        }, " 返回 ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: ($event: any) => (_ctx.changeNav(index)),
            class: _normalizeClass([_ctx.currentIndex === index && 'active']),
            key: index
          }, _toDisplayString(item.name), 11, _hoisted_7))
        }), 128))
      ]),
      _createElementVNode("ul", {
        class: _normalizeClass([_ctx.navList[_ctx.currentIndex].type + '-list'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList[_ctx.currentIndex].list, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            onClick: ($event: any) => (_ctx.handleItem(item, index))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["img", [item.info.newsType === '视频文章' && 'video']])
            }, [
              _createElementVNode("img", {
                src: _ctx.imgCrop(item.info.image, _ctx.navList[_ctx.currentIndex].type),
                alt: ""
              }, null, 8, _hoisted_9)
            ], 2),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", null, _toDisplayString(item.info.title), 1)
            ])
          ], 8, _hoisted_8))
        }), 128))
      ], 2)
    ]),
    (_ctx.picViewerData)
      ? (_openBlock(), _createBlock(_component_PictureViewer, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}